export default "__VITE_ASSET__BMIEnvJd__"